import { render } from "./DataDeletionRequestForm.vue?vue&type=template&id=7d18bf9a&scoped=true"
import script from "./DataDeletionRequestForm.vue?vue&type=script&lang=js"
export * from "./DataDeletionRequestForm.vue?vue&type=script&lang=js"

import "./DataDeletionRequestForm.vue?vue&type=style&index=0&id=7d18bf9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d18bf9a"]])

export default __exports__